/* eslint-disable react/jsx-no-undef */
import React, { useContext, useEffect, useState } from 'react'
import {Helmet} from "react-helmet";
import { CartContext } from '../../Context/CartContext'
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import "./Cart.css"

export default function Cart() {
  const [isLoading, setIsloading] = useState(false);
  let {getLoggedUserCart,cartDetails,setCartDetails, deleteItem, updateProductCount,clearCart,setNumOfCarts} = useContext(CartContext);
  async function getCart() {
    setIsloading(true);
    let response = await getLoggedUserCart();
    if(response?.data?.status === "success") {
      setCartDetails(response.data.data);
      setIsloading(false)
      console.log(response)
    }
  }

  async function updateProductQuantity(productId,count) {

    let response = await updateProductCount(productId,count);
    setCartDetails(response.data.data);
    setNumOfCarts(response.data.numOfCartItems)
    toast("product count updated!")
  }
  async function clearProducts() {
    let response = await clearCart();
        setCartDetails(response.data.data);
        setNumOfCarts(response.data.numOfCartItems)
        toast("All products have been deleted succefully!");
        getCart()
  }
  useEffect(() => {
    getCart()
  },[])

  return (
    <div style={{marginBottom:"100px", marginTop:"80px"}}>
      <Helmet>
        <title>Cart Details</title>
      </Helmet>
    {cartDetails ? <div className="bg-main-light">
        <h3>Shop Cart: </h3>
        <h6 className='text-main'>Total Cart Price: {cartDetails.totalCartPrice} EGP</h6>
        {cartDetails.products.map((product) => <div key={product.product._id} className='row align-items-center border-bottom p-2 my-2 w-100 '>
            <div className="col-md-2">
              <img className='w-100' src={product.product.imageCover} alt="" />
            </div>
            <div className="col-md-10 d-flex justify-content-between">
              <div>
              <h6>{product.product.title}</h6>
              <h6 className='text-main'>Price: {product.price}</h6>
              <button onClick={() => {
                deleteItem(product.product._id);
              }} className='btn m-0 p-0 any'><i className='fa-regular text-main fa-trash-can '></i> Remove</button>
              </div>
              <div>
                <button onClick={() => {
                  updateProductQuantity(product.product._id, product.count + 1)
                }} className='btn border-main btn-sm update'>+</button>
                <span className='mx-2'>{product.count}</span>
                <button onClick={() => {
                  updateProductQuantity(product.product._id, product.count - 1);
                }} className='btn border-main btn-sm update'>-</button>
              </div>
            </div>
        </div>)}
        <button className='btn bg-main d-block my-3 special' onClick={clearProducts}>
          CLear All
        </button>
        <button className='btn bg-main special'>
          <Link to="/checkout">Checkout</Link>
        </button>
    </div>: <div className='div-spin'><i className='fas fa-spinner fa-spin fa-3x text-main'></i></div>}
    
    <h2>Cart</h2>
    </div>
    
  )
}
